import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const footerSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '六合彩指南',
    url: 'https://liuhecai-zhinan.example.com',
    description: '汇聚最权威的六合彩网站资讯，涵盖平台评测、开奖结果查询、玩法规则解析及选号技巧。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@liuhecai-zhinan.example.com',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <script type="application/ld+json">{JSON.stringify(footerSchema)}</script>
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-vip-crown-line text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-foreground-900">六合彩指南</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              汇聚最权威的六合彩网站资讯，涵盖平台评测、开奖结果查询、玩法规则解析及选号技巧，助您安全理性参与娱乐。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">分类导航</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors flex items-center gap-2"
                  >
                    <i className={`${cat.icon} text-xs`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">热门文章</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/liuhecai-jiben-wanfa-xiangjie" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  六合彩基本玩法详解
                </Link>
              </li>
              <li>
                <Link to="/article/xuahao-jiqiao-lengrementongji" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  冷热门号码统计分析法
                </Link>
              </li>
              <li>
                <Link to="/article/zhengqui-pingtai-ruhe-bianbie" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  正规平台辨别指南
                </Link>
              </li>
              <li>
                <Link to="/article/kaijiang-jieguo-zuixin-chaxun" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  最新开奖结果查询
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">关于本站</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-xs text-foreground-500">
                联系邮箱：contact@liuhecai-zhinan.example.com
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 六合彩指南 - 版权所有。本站仅供资讯参考，不提供投注服务。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">理性博彩，量力而行</span>
          </div>
        </div>
      </div>
    </footer>
  );
}